// TransactionServiceClient.ts - Frontend-safe client for transaction operations
import axios from 'axios';

export class TransactionServiceClient {
  private static baseUrl = '/api/transactions';

  static async create(transactionData: any): Promise<any> {
    try {
      const response = await axios.post(this.baseUrl, transactionData);
      return response.data;
    } catch (error) {
      console.error('Error creating transaction:', error);
      throw error;
    }
  }

  static async approve(transactionId: string, userId: string): Promise<any> {
    try {
      const response = await axios.post(`${this.baseUrl}/${transactionId}/approve`, { userId });
      return response.data;
    } catch (error) {
      console.error('Error approving transaction:', error);
      throw error;
    }
  }

  static async createRecurring(recurringData: any): Promise<any> {
    try {
      const response = await axios.post(`${this.baseUrl}/recurring`, recurringData);
      return response.data;
    } catch (error) {
      console.error('Error creating recurring transaction:', error);
      throw error;
    }
  }
} 